import Button from '@root/core/src/components/button';
import Header from '@root/core/src/components/header';
import PropTypes from '@root/vendor/prop-types';
import React from '@root/vendor/react';
import SceneContent from '@root/core/src/components/scene-content';
import SceneWrapper from '@root/core/src/components/scene-wrapper';
import errorSign from '@root/core/src/assets/error-sign.svg';
import { StyleSheet, Theme } from '@root/core/src/utils/styles';

export const GENERIC_ERROR_SCREEN_MESSAGE = 'Oops, something went wrong.';

export default function Error({
  buttonText, onClick, showHeader,
}) {
  const containerCss = [styles.container];
  if (showHeader) {
    containerCss.push(styles.containerHeaderPadding);
  }

  return (
    <>
      {showHeader && <Header />}
      <SceneWrapper>
        <SceneContent>
          <div css={styles.centerAlign}>
            <img
              alt={'car accident'}
              css={styles.image}
              src={errorSign}
            />
          </div>
          <p css={styles.title}>{GENERIC_ERROR_SCREEN_MESSAGE}</p>
          <p css={styles.body}>
            We’re sorry, we’ve run into a problem on our end. We’re working to fix the issue as quickly as possible and will let you know once it’s resolved.
          </p>
          <Button
            onClick={onClick}
            type={'button'}
          >
            {buttonText}
          </Button>
        </SceneContent>
      </SceneWrapper>
    </>
  );
}

Error.propTypes = {
  buttonText: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  showHeader: PropTypes.bool.isRequired,
};

const styles = StyleSheet.create({
  body: {
    ...Theme.paragraph1(),
    marginBottom: 10,
  },
  centerAlign: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  image: {
    maxWidth: '100%',
  },
  title: {
    ...Theme.heading2(),
  },
});
